import { render, staticRenderFns } from "./vipLayout.vue?vue&type=template&id=5eca2785&"
import script from "./vipLayout.vue?vue&type=script&lang=js&"
export * from "./vipLayout.vue?vue&type=script&lang=js&"
import style0 from "./vipLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports